export const RFM_OBTER_CONFIG = "RFM_OBTER_CONFIG";
export const RFM_SALVAR_CONFIG = "RFM_SALVAR_CONFIG";
export const RFM_SIMULAR = "RFM_SIMULAR";
export const RFM_LISTAR_SEGMENTOS = "RFM_LISTAR_SEGMENTOS";
